module.exports = __webpack_public_path__ + "img/Pic_Services-2.1d987f00.jpg";